import { createContext } from 'react';
import webLoginContextType from '../types/web/webLoginContextType';

// export const LoginContext = createContext<any>(new webLogin());
export const LoginContext = createContext<webLoginContextType | undefined>(undefined);
